import { ContentLayout } from "@cloudscape-design/components";
import { AppHeader } from "../commons/header";
import ProviderCapabilityTablePage from "./commons/provider-capability-table";

export default function ManagementPage(){
    return (
        <ContentLayout
        headerVariant="high-contrast"
            header={
                <AppHeader
                  breadcrumbs={[
                    { text: "Provider Capability Map", href: "/" },
                    { text: "Management", href: "/" },
                  ]}
                  header={"Manage Provider Capabilities"}
                  description="Hier kann gepflegt werden, welcher Provider, welche Technical Service Offerings erbringen könnte"
                />
            }
          >
            <ProviderCapabilityTablePage />
          </ContentLayout>
    )
}